import React, { useState, useEffect } from 'react';

const SimplePhoneInput = ({ value, onChange, className, error }) => {
  const [countryCode, setCountryCode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [flag, setFlag] = useState('🌍');
  const [placeholder, setPlaceholder] = useState('Enter phone number');

  // Country code to flag and placeholder mapping
  const countryData = {
    '+1': { flag: '🇺🇸', placeholder: '202 555 0100', name: 'US/Canada' },
    '+44': { flag: '🇬🇧', placeholder: '20 7946 0958', name: 'UK' },
    '+254': { flag: '🇰🇪', placeholder: '724 749 763', name: 'Kenya' },
    '+234': { flag: '🇳🇬', placeholder: '803 123 4567', name: 'Nigeria' },
    '+27': { flag: '🇿🇦', placeholder: '82 123 4567', name: 'South Africa' },
    '+256': { flag: '🇺🇬', placeholder: '712 345 678', name: 'Uganda' },
    '+255': { flag: '🇹🇿', placeholder: '754 123 456', name: 'Tanzania' },
    '+250': { flag: '🇷🇼', placeholder: '788 123 456', name: 'Rwanda' },
    '+91': { flag: '🇮🇳', placeholder: '98765 43210', name: 'India' },
    '+86': { flag: '🇨🇳', placeholder: '138 0013 8000', name: 'China' },
    '+81': { flag: '🇯🇵', placeholder: '90 1234 5678', name: 'Japan' },
    '+49': { flag: '🇩🇪', placeholder: '30 12345678', name: 'Germany' },
    '+33': { flag: '🇫🇷', placeholder: '6 12 34 56 78', name: 'France' },
    '+61': { flag: '🇦🇺', placeholder: '412 345 678', name: 'Australia' },
    '+55': { flag: '🇧🇷', placeholder: '11 99999 9999', name: 'Brazil' },
    '+52': { flag: '🇲🇽', placeholder: '55 1234 5678', name: 'Mexico' },
    '+7': { flag: '🇷🇺', placeholder: '495 123 45 67', name: 'Russia' },
  };

  // Parse existing value on component mount
  useEffect(() => {
    if (value) {
      // Find the country code in the value
      const codes = Object.keys(countryData).sort((a, b) => b.length - a.length);
      const foundCode = codes.find(code => value.startsWith(code));
      
      if (foundCode) {
        setCountryCode(foundCode);
        setPhoneNumber(value.slice(foundCode.length).trim());
        updateDisplay(foundCode);
      } else {
        // If no country code found, try to extract it
        const match = value.match(/^(\+\d{1,4})/);
        if (match) {
          const code = match[1];
          setCountryCode(code);
          setPhoneNumber(value.slice(code.length).trim());
          // Check if we have data for this code, otherwise use generic
          if (countryData[code]) {
            updateDisplay(code);
          } else {
            setFlag('🌍');
            setPlaceholder('Enter phone number');
          }
        }
      }
    }
  }, []);

  const updateDisplay = (code) => {
    const data = countryData[code];
    if (data) {
      setFlag(data.flag);
      setPlaceholder(data.placeholder);
    } else {
      setFlag('🌍');
      setPlaceholder('Enter phone number');
    }
  };

  const handleCountryCodeChange = (e) => {
    let input = e.target.value;
    
    // Ensure it starts with +
    if (input && !input.startsWith('+')) {
      input = '+' + input;
    }
    
    setCountryCode(input);
    
    // Update flag and placeholder
    updateDisplay(input);
    
    // Update the parent component
    const fullNumber = input + phoneNumber;
    onChange(fullNumber);
  };

  const handlePhoneNumberChange = (e) => {
    const input = e.target.value;
    setPhoneNumber(input);
    
    // Update the parent component
    const fullNumber = countryCode + input;
    onChange(fullNumber);
  };

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-3 gap-3">
        {/* Country Code Input */}
        <div className="relative">
          <input
            type="text"
            value={countryCode}
            onChange={handleCountryCodeChange}
            placeholder="+254"
            className={`w-full bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-center ${className}`}
            style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
              boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.1)',
              paddingLeft: '2.5rem'
            }}
          />
          <div className="absolute inset-y-0 left-2 flex items-center pointer-events-none">
            <span className="text-lg">{flag}</span>
          </div>
        </div>
        
        {/* Phone Number Input */}
        <div className="col-span-2">
          <input
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
            placeholder={placeholder}
            className={`w-full bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-3 text-white focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${className}`}
            style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
              boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.1)'
            }}
          />
        </div>
      </div>
      
      {error && <p className="text-red-400 text-sm">{error}</p>}
    </div>
  );
};

export default SimplePhoneInput;